import React, { Suspense, useEffect, useState, useMemo, lazy } from 'react';

import { LTLoader } from '@lambdatestincprivate/lt-components';

import { Provider } from 'react-redux';

import createMyStore from '../../redux/store';
import { initializeEnv } from '../../utils/env';

import ShareModal from './ShareModal';
export default function App(props) {
  const env = props.env || {};
  const [isEnvReady, setIsEnvReady] = useState(false);

  // Initialize env registry and mark as ready when env is available
  useEffect(() => {
    if (env && Object.keys(env).length > 0) {
      initializeEnv(env);
    }
    setIsEnvReady(true);
  }, [env]);

  // Create store with env object only after env is ready
  const store = useMemo(() => {
    if (!isEnvReady) {
      return null;
    }
    return createMyStore(env);
  }, [env, isEnvReady]);

  if (!isEnvReady || !store) {
    return null;
  }

  return (
    <Provider store={store}>
      <Suspense fallback={<LTLoader />}>
        <ShareModal {...props} />
      </Suspense>
    </Provider>
  );
}
